module.exports = __webpack_public_path__ + "img/grayGoodSigh.047684c1.svg";